import React from 'react';

export const VARIANT_1 = {
  title: (
    <>
      The hands-off way to collect rent. <span>For free.</span>
    </>
  ),
  blocks: [
    {
      icon: 'receiving-money',
      title: 'Effortless automation',
      description:
        'Automatic charges, receipts, and late fees save you time every month.',
      link: {
        text: 'How it works',
        trackingEvent: 'how_it_works clicked',
      },
    },
    {
      icon: 'tenants',
      title: 'Easy and automatic for your tenants',
      description:
        'They can pay online or through our app, with options for autopay.',
    },
    {
      icon: 'pre-screener',
      title: 'Your rental business, in one place',
      description:
        'No matter how they pay, all your payments are organized with the rest of your rental business.',
    },
    {
      icon: 'security',
      title: 'Bank-level security',
      description:
        'We use the same processes that big banks use to keep your payments secure.',
    },
  ],
  buttonText: 'Setup rent collection',
};

export const VARIANT_2 = {
  title: (
    <>
      Collect rent, without the back-and-forth. <span>For free.</span>
    </>
  ),
  blocks: [
    {
      icon: 'receiving-money',
      title: 'No nagging your tenants, just get paid',
      description:
        "With automatic reminders and late fees, you don't have to be the bad guy. We are.",
    },
    {
      icon: 'purchase-house',
      title: 'Professionalism without the fee',
      description:
        "Tenants get auto-pay, automatic receipts, a mobile app, and more. Just like the big property managers —but it's free for you.",
    },
    {
      icon: 'pre-screener',
      title: 'Your rental business, in one place',
      description:
        'No matter how they pay, all your payments are organized with the rest of your rental business.',
    },
    {
      icon: 'security',
      title: 'Bank-level security',
      description:
        'We use the same processes that big banks use to keep your payments secure.',
    },
  ],
  buttonText: 'Setup rent collection',
};
